import React, { useState, useEffect, useRef } from "react";
import * as Icons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useForm } from "react-hook-form";
import { customAPI } from "services/utils/CustomAPI";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import { Info, Edit, FileCopy } from "@mui/icons-material";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { showToast } from "services/utils/Status";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { tableRowSx } from "services/constants";
import { themes } from "services/constants";
import { useSelector } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { useFetch } from "services/hooks/useFetch";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { formKeyText } from "services/constants/Styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { IndividualLeaveGroup } from "services/constants";
import { Loader } from "components/Loader";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { tooltipStyleProps } from "services/constants/Styles";

const leaveGroupHeader = [
  {
    name: "Version",
    key: "version",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },

  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Leave Type",
    key: "leave_type",
  },
  {
    name: "Last Crediting Date",
    key: "last_credited_date",
  },
  {
    name: "Action",
    key: "actions",
  },
];

export const IndividualLeaveGroupUd = ({
  setView,
  edit,
  setFetchLeaveGroupData,
}) => {
  const [type, setType] = useState(false);
  const [showData, setShowData] = useState(false);
  const [storedItem, setStoredItem] = useState([]);
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [effectiveFrom, setEffectiveFrom] = useState(dayjs());
  const [openDialog, setOpenDialog] = useState(false);
  const { result: leaveTypeList } = useFetch(`${domain}new-leave-type/`);
  const {
    result: IndividualLeaveGroupData,
    setLoad: recallApi,
    loading,
  } = useFetch(
    `${domain}configuration-leave-group/?leave_group_id=${edit?.id}`
  );
  const dispatch = useDispatch();
  const [selectedLeaveType, setSelectedLeaveType] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [viewData, setViewData] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dateError, setDateError] = useState(false);
  // const [leaveTypeError, setLeaveTypeError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [reducedDate, setReducedDate] = useState();
  const [buttonLoader, setButtonLoader] = useState(false);
  const containerRef = useRef(null);

  const versionData = showData ? storedItem?.version + 1 : 1;
  const filteredLeaveTypes =
    leaveTypeList?.filter((item) => item.no_of_configuration !== 0) || [];

  const {
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  useEffect(() => {
    if (storedItem?.effective_from && trigger) {
      (type || showData) && versionData > 1
        ? setEffectiveFrom(dayjs())
        : setEffectiveFrom(dayjs(storedItem.effective_from), "YYYY/MM/DD");
      // type
      //   ? setReducedDate(
      //       dayjs(storedItem.effective_from).subtract(1, "day"),
      //       "YYYY/MM/DD"
      //     )
      //   : setReducedDate(dayjs());

      type
        ? setReducedDate(
            dayjs(storedItem.effective_from).subtract(1, "day"),
            "YYYY/MM/DD"
          )
        : setReducedDate(dayjs().subtract(1, "day"), "YYYY/MM/DD");
      const selectedIds = storedItem?.leave_types.map((item) => item.id);
      setSelectedLeaveType(selectedIds);
      setTrigger(false);
    }
  }, [
    effectiveFrom,
    showData,
    storedItem,
    storedItem.effective_from,
    trigger,
    type,
    versionData,
  ]);

  const handleClose = () => {
    if (edit?.no_of_configuration === 0) {
      setView("LeaveGroup");
    } else {
      setOpenDialog(false);
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  const handleEffectiveFrom = (value) => {
    setEffectiveFrom(value);
    if ((value !== null && showData) || type) {
      setReducedDate(value.subtract(1, "day"));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const AddShiftGroup = async () => {
    if (effectiveFrom && effectiveFrom.toString() !== "Invalid Date") {
      setButtonLoader(true);
      let payload = {
        leave_group_id: edit?.id,
        version: type ? storedItem?.version : versionData,
        effective_from: effectiveFrom.format("YYYY-MM-DD"),
        effective_to: null,
        ...((showData || type) && {
          pre_ver_effective_to: reducedDate.format("YYYY-MM-DD"),
        }),
        leave_types: selectedLeaveType,
      };

      const method = type || showData ? "PUT" : "POST";
      const url =
        type || showData
          ? `${domain}configuration-leave-group/${storedItem?.id}/`
          : `${domain}configuration-leave-group/`;

      const response = await customAPI(url, method, payload);
      if (response.ok) {
        showToast("success", "Leave group created successfully");
        recallApi(true);
        setFetchLeaveGroupData(true);
        setOpenDialog(false);
        setDateError(false);
        setButtonLoader(false);
        // setLeaveTypeError(false);
        reset();
      } else {
        setButtonLoader(false);
      }
    } else {
      if (
        (effectiveFrom === null ||
          effectiveFrom.toString() === "Invalid Date") &&
        selectedLeaveType?.length === 0
      ) {
        setDateError(true);
        // setLeaveTypeError(true);
      } else if (selectedLeaveType?.length === 0) {
        setDateError(false);
        // setLeaveTypeError(true);
      } else if (
        effectiveFrom === null ||
        effectiveFrom.toString() === "Invalid Date"
      ) {
        setDateError(true);
        // setLeaveTypeError(false);
      }
    }
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => {
      if (!acc) return undefined;
      if (Array.isArray(acc) && part === "name") {
        return acc.map((item) => item.name).join(", ");
      }
      return acc[part];
    }, obj);
  };

  useEffect(() => {
    if (IndividualLeaveGroupData?.length !== 0) {
      const filteredResults = IndividualLeaveGroupData.filter((item) =>
        IndividualLeaveGroup.some((key) =>
          getNestedValue(item, key)
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );
      setLeaveData(filteredResults);
      setPage(globalSearchValue ? 0 : page);
      setViewData(true);
    }
  }, [IndividualLeaveGroupData, globalSearchValue, page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      {leaveData?.length === 0 &&
        edit?.no_of_configuration === 0 &&
        !loading &&
        !viewData && (
          <>
            <Mui.Grid container>
              <BackArrow
                actionFunction={() => {
                  setView("LeaveGroup");
                  dispatch(setGlobalSearchValue(""));
                }}
              />
              <Mui.Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: 22,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Leave Group / {edit?.name}
              </Mui.Typography>
            </Mui.Grid>

            <Mui.Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "92vh" }}
            >
              <Mui.Grid>
                <CustomButton
                  actionFuntion={() => {
                    if (
                      checkEditorPermission(
                        userScreenAccess?.module_details,
                        "LMS",
                        "Leave Group"
                      )
                    ) {
                      setOpenDialog(true);
                    } else {
                      showToast(
                        "error",
                        "Access denied: You are not authorized to add new configuration"
                      );
                    }
                  }}
                  actionName={"Add new configuration"}
                  typeName="button"
                />
              </Mui.Grid>
            </Mui.Grid>
          </>
        )}
      <GlobalDialogBox
        handleCloseDialog={() => handleClose()}
        title={
          type
            ? "Edit Leave Group Configuration"
            : showData
            ? "Clone Leave Group Configuration"
            : "Add Leave Group Configuration"
        }
        open={openDialog}
        minWidth={820}
      >
        <Mui.Grid container sx={{ paddingBottom: 1 }}>
          <>
            {showData && versionData > 1 && (
              <Mui.Grid
                container
                sx={{
                  border: `2px solid ${themes.sidebarDivider}`,
                  backgroundColor: themes?.primary,
                  padding: 0.5,
                }}
              >
                <Mui.Grid xs={3}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Version :{storedItem?.version}{" "}
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={4.5}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Effective From :
                    {dayjs(storedItem?.effective_from).format("DD/MM/YYYY")}
                  </Mui.Typography>
                </Mui.Grid>

                <Mui.Grid xs={4.5}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Effective To :{dayjs(reducedDate).format("DD/MM/YYYY")}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
            )}

            {type && storedItem?.version > 1 && (
              <Mui.Grid
                container
                sx={{
                  border: `2px solid ${themes.sidebarDivider}`,
                  padding: 0.5,
                  backgroundColor: themes?.primary,
                }}
              >
                <Mui.Grid xs={3}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Version :{storedItem?.pre_version_data?.pre_version}
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={4.5}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Effective From :{" "}
                    {dayjs(
                      storedItem?.pre_version_data?.pre_ver_effective_from
                    ).format("DD/MM/YYYY")}
                  </Mui.Typography>
                </Mui.Grid>

                <Mui.Grid xs={4.5}>
                  <Mui.Typography
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    Effective To : {dayjs(reducedDate).format("DD/MM/YYYY")}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
            )}
          </>

          <Mui.Grid container sx={{ padding: 1 }}>
            <Mui.Grid xs={1}></Mui.Grid>
            <Mui.Grid xs={4.5}>
              <Mui.Typography sx={formKeyText}>
                Leave Group Name &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={
                    type
                      ? "Update the name of the leave group, which organizes multiple leave types under a common policy."
                      : showData
                      ? "Enter a name for the cloned leave group. This will be a duplicate of an existing leave group with modifications as needed."
                      : "Enter the name of the leave group, which organizes multiple leave types under a common policy."
                  }
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>{" "}
            </Mui.Grid>
            <Mui.Grid xs={0.5}></Mui.Grid>
            <Mui.Grid xs={4}>
              <Mui.Typography sx={{ paddingTop: 2 }}>
                {storedItem?.name ? storedItem?.name : edit?.name}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ padding: 1 }}>
            <Mui.Grid xs={1}></Mui.Grid>
            <Mui.Grid xs={4.5}>
              <Mui.Typography sx={formKeyText}>
                Version &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={
                    type
                      ? "Update the version of this leave group configuration to track changes and revisions."
                      : showData
                      ? "Specify the version of this cloned leave group configuration to track changes and updates."
                      : "Indicates the version of the leave group configuration, useful for tracking updates and changes."
                  }
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>{" "}
            </Mui.Grid>
            <Mui.Grid xs={0.5}></Mui.Grid>
            <Mui.Grid xs={4}>
              <Mui.Typography sx={{ paddingTop: 2 }}>
                {type ? storedItem?.version : versionData}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ padding: 1 }}>
            <Mui.Grid xs={1}></Mui.Grid>
            <Mui.Grid xs={4.5}>
              <Mui.Typography sx={formKeyText}>
                Effective From &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={
                    type
                      ? "Set or update the date when the modified leave group configuration will take effect."
                      : showData
                      ? "Set the date from which this cloned leave group will become active."
                      : "Set the date when this leave group configuration will become active."
                  }
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>{" "}
            </Mui.Grid>
            <Mui.Grid xs={0.5}></Mui.Grid>
            <Mui.Grid xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  style={{ width: "100%" }}
                >
                  <DatePicker
                    size="small"
                    slotProps={{
                      textField: {
                        size: "small",
                        inputProps: { readOnly: true },
                      },
                    }}
                    value={effectiveFrom}
                    format="DD/MM/YYYY"
                    onChange={handleEffectiveFrom}
                    // minDate={dayjs().add(1, "day")}
                    // minDate={dayjs()}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        size="small"
                        fullWidth
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {dateError && (
                <Mui.Typography
                  variant="body2"
                  color="error"
                  sx={{ fontSize: 13, px: 0.5, py: 0.8 }}
                >
                  {dateError
                    ? "Date is required"
                    : "Date cannot be in the past."}
                </Mui.Typography>
              )}
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ padding: 1 }}>
            <Mui.Grid xs={1}></Mui.Grid>
            <Mui.Grid xs={4.5}>
              <Mui.Typography sx={formKeyText}>
                Leave Type &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={
                    type
                      ? "Edit or update the leave types included in this leave group, such as Annual Leave, Sick Leave, or Maternity Leave."
                      : showData
                      ? "Select or modify the leave types included in this cloned leave group, such as Annual Leave, Sick Leave, or Maternity Leave."
                      : "Select the leave types included in this leave group, such as  Sick Leave, or casual Leave."
                  }
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>{" "}
            </Mui.Grid>
            <Mui.Grid xs={0.5}></Mui.Grid>
            <Mui.Grid xs={6} sx={{ paddingTop: 0.8 }}>
              <Mui.Autocomplete
                multiple
                id="checkboxes-tags-demo"
                size="small"
                disableCloseOnSelect
                options={filteredLeaveTypes}
                getOptionLabel={(option) => option.name}
                value={
                  filteredLeaveTypes?.filter((member) =>
                    selectedLeaveType.includes(member.id)
                  ) || []
                }
                ListboxProps={{
                  style: {
                    maxHeight: "200px",
                  },
                }}
                onChange={(event, value) => {
                  setSelectedLeaveType(value.map((item) => item.id));
                  if (value.length > 0) {
                    clearErrors("leaveType");
                  }
                }}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Mui.Checkbox
                        icon={<Icons.CheckBoxOutlineBlank fontSize="small" />}
                        checkedIcon={<Icons.CheckBox fontSize="small" />}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <Mui.TextField
                    {...params}
                    multiline
                    rows={1}
                    maxRows={1}
                    placeholder={
                      selectedLeaveType.length === 0 ? "Select leave type" : ""
                    }
                    error={Boolean(errors.leaveType)}
                    helperText={errors.leaveType?.message || ""}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <Icons.AcUnit
                            style={{
                              margin: "0 8px",
                              color: "#a6a6a6",
                            }}
                          />
                          {params.InputProps.startAdornment} &nbsp;{" "}
                        </>
                      ),
                    }}
                  />
                )}
              />
              {/* {leaveTypeError ? (
                <Mui.Typography
                  variant="body2"
                  color="error"
                  sx={{ fontSize: 13, px: 0.5, py: 0.8 }}
                >
                  Select atleast one leave type
                </Mui.Typography>
              ) : null} */}
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Stack
          sx={{
            display: "flex",
            paddingTop: 1,
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <CustomButton
            actionFuntion={() => {
              if (
                leaveData?.length === 0 &&
                edit?.no_of_configuration === 0 &&
                !loading
              ) {
                setView("LeaveGroup");
              } else {
                setOpenDialog(false);
                // setLeaveTypeError(false);
                setDateError(false);
              }
            }}
            actionName="Cancel"
            typeName="button"
          />
          &nbsp;&nbsp;
          <CustomButton
            actionFuntion={() => {
              AddShiftGroup();
            }}
            actionName={type ? "Update" : showData ? "Clone" : "Add"}
            disableAction={type || showData ? buttonLoader : buttonLoader}
            typeName="submit"
          />
        </Mui.Stack>
      </GlobalDialogBox>

      {(leaveData?.length !== 0 || viewData) && (
        <Mui.Grid container sx={{ paddingLeft: 2, paddingRight: 2 }}>
          {loading ? (
            <Loader info="Loading..." />
          ) : (
            <>
              <Mui.Grid container xs={12}>
                <BackArrow
                  actionFunction={() => {
                    setView("LeaveGroup");
                    dispatch(setGlobalSearchValue(""));
                  }}
                />
                <Mui.Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 22,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Leave Group /{edit?.name}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.TableContainer
                ref={containerRef}
                component={Mui.Paper}
                sx={{ mt: 2, width: "100%" }}
              >
                <Mui.Table>
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                    }}
                  >
                    <Mui.TableRow sx={tableRowSx}>
                      {leaveGroupHeader?.map((value) => (
                        <Mui.TableCell
                          sx={{ color: themes.headLine, fontWeight: "bold" }}
                        >
                          {value?.name}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {leaveData?.length === 0 ? (
                      <InfoMessage dataLength={IndividualLeaveGroupData} />
                    ) : (
                      leaveData
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((value) => (
                          <Mui.TableRow sx={tableRowSx}>
                            {leaveGroupHeader.map((head) =>
                              head.name === "Leave Type" ? (
                                <Mui.TableCell>
                                  {value.leave_types.length > 2 ? (
                                    <Mui.Tooltip
                                      arrow
                                      slotProps={tooltipStyleProps}
                                      title={value.leave_types
                                        .map((leave) => leave.name)
                                        .join(", ")}
                                    >
                                      <span>
                                        {value.leave_types
                                          .slice(0, 2)
                                          .map((leave) => leave.name)
                                          .join(", ")}{" "}
                                        +{value.leave_types.length - 2} more
                                      </span>
                                    </Mui.Tooltip>
                                  ) : value.leave_types.length > 0 ? (
                                    value.leave_types
                                      .map((leave) => leave.name)
                                      .join(", ")
                                  ) : (
                                    "N/A"
                                  )}
                                </Mui.TableCell>
                              ) : head.name === "Effective From" ? (
                                <Mui.TableCell>
                                  {value.effective_from
                                    ? dayjs(value.effective_from).isValid()
                                      ? dayjs(value.effective_from).format(
                                          "DD/MM/YYYY"
                                        )
                                      : "N/A"
                                    : "N/A"}
                                </Mui.TableCell>
                              ) : head.name === "Effective To" ? (
                                <Mui.TableCell>
                                  {value.effective_to
                                    ? dayjs(value.effective_to).isValid()
                                      ? dayjs(value.effective_to).format(
                                          "DD/MM/YYYY"
                                        )
                                      : "N/A"
                                    : "N/A"}
                                </Mui.TableCell>
                              ) : head.name === "Last Crediting Date" ? (
                                <Mui.TableCell>
                                  {value.last_credited_date
                                    ? dayjs(value.last_credited_date).isValid()
                                      ? dayjs(value.last_credited_date).format(
                                          "DD/MM/YYYY"
                                        )
                                      : "N/A"
                                    : "N/A"}
                                </Mui.TableCell>
                              ) : head.name === "Action" ? (
                                <Mui.TableCell>
                                  {value?.is_editable || value?.is_cloneable ? (
                                    <>
                                      {value?.last_credited_date ? (
                                        <Mui.IconButton
                                          onClick={() => {
                                            if (
                                              checkEditorPermission(
                                                userScreenAccess?.module_details,
                                                "LMS",
                                                "Leave Group"
                                              )
                                            ) {
                                              setOpenDialog(true);
                                              setShowData(true);
                                              setType(false);
                                              setStoredItem(value);
                                              setTrigger(true);
                                            } else {
                                              showToast(
                                                "error",
                                                "Access denied: You are not authorized to clone this leave group"
                                              );
                                            }
                                          }}
                                        >
                                          <FileCopy />
                                        </Mui.IconButton>
                                      ) : (
                                        <Mui.IconButton
                                          onClick={() => {
                                            if (
                                              checkEditorPermission(
                                                userScreenAccess?.module_details,
                                                "LMS",
                                                "Leave Group"
                                              )
                                            ) {
                                              setOpenDialog(true);
                                              setShowData(false);
                                              setType(true);
                                              setStoredItem(value);
                                              setTrigger(true);
                                            } else {
                                              showToast(
                                                "error",
                                                "Access denied: You are not authorized to edit this leave group"
                                              );
                                            }
                                          }}
                                        >
                                          <Edit />
                                        </Mui.IconButton>
                                      )}
                                    </>
                                  ) : null}
                                </Mui.TableCell>
                              ) : (
                                <Mui.TableCell>
                                  {value[head.key] ? value[head.key] : "N/A"}
                                </Mui.TableCell>
                              )
                            )}
                          </Mui.TableRow>
                        ))
                    )}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
            </>
          )}
          <Mui.Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {leaveData?.length > 25 ? (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={leaveData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            ) : null}
          </Mui.Grid>
        </Mui.Grid>
      )}
    </React.Fragment>
  );
};
